export enum AppRoutes {
	Home = '/',
	DomainSelection = '/',
	VirtualCockpit = '/virtual-cockpit',
	AutomatedPlan = '/automated-plan',
	AutomatedPlanAllTasks = '/automated-plan/tasks',
	TaskCreation = '/automated-plan/task-creation',
	EditTask = '/automated-plan/edit-task/:id',
	OilAnalysis = '/oil-analysis',
	HistoricalData = '/historical-data',
	AggregadeData = '/aggregate-data',
	Dashboard = '/dashboard',
	YachtView = '/yacht-view',
	PlantView = '/plant-view',
	MultiYachtView = '/multi-yacht-view',
	MultiPlantView = '/multi-plant-view',
	YachtTrack = '/yacht-track',
	Profile = '/profile',
	Settings = '/profile/timezone-etc',
	Faq = '/profile/faq',
	FaqPrivacy = '/profile/faq/privacy-policy',
	FaqTermsOfService = '/profile/faq/terms-of-service',
	AgreementsSettings = '/agreements-settings',
	YachtsFleet = '/yachts-fleet',
	PlantsManagement = '/plants-management',
	EditYacht = '/yachts-fleet/edit-yacht/:id',
	EditPlant = '/plants-management/edit-plant/:id',
	Support = '/support',
	HelpCenter = '/help-center',
	Privacy = '/privacy-policy',
	TermsOfService = '/terms-of-service',
	Login = '/login',
	LoginCallback = '/login/callback',
	AlarmDashboard = '/alarm/dashboard',
	AlarmManagement = '/alarm/management',
	StatusHistory = '/status/history',
	StatusDashboard = '/status/dashboard',
	GroupManagement = '/access-management',
	GroupManagementMembers = '/access-management/:groupId',
	GroupManagementBrandDetails = '/access-management/:groupId/:brandId',
	GroupManagementTeamDetails = '/access-management/:groupId/:brandId/:teamId',
}
